// "Tax File Ready" tab (2026-08-31): client-canonical tax-document flags.
// These are VIRTUAL columns — no spreadsheet_columns rows exist; the V2
// loader overlays them from public.clients (sql/workflow-v2/011) and saves
// go through update_client_services_for_v2. The display names below double
// as the overlay's row_data keys and must match the SQL exactly.

/** Tab columns in display order. All booleans except 1099K (doc_1099k). */
export const TAX_FILE_READY_COLUMNS = [
  'W2',
  'W3',
  'W4',
  'W9',
  '1099K',
  '1099R',
  'K1',
  'ENDING INVENTORY',
  'RENTAL PROPERTY',
  'BROILER STATEMENT REPORT',
  '1095A',
  'ID PIN',
  'STOCK STATEMENT',
  'CRYPTO',
] as const;

/**
 * The 1099K dropdown's toggles, in menu order. Stored in clients.tax_1099k
 * as a jsonb object of {option: boolean} — a missing key means false. The
 * option list lives here only (no DB constraint), so adding a platform is a
 * frontend-only change.
 */
export const TAX_1099K_OPTIONS = [
  '1099K',
  'CHOWBUS',
  'DOORDASH',
  'GRUBHUB',
  'SQUARE',
  'TAPTAP',
  'TOAST',
  'UBEREATS',
] as const;

/** The options currently toggled on inside a tax_1099k value, in menu order
 *  (unknown/legacy keys set to true are appended so they stay visible). */
export function selected1099KOptions(value: unknown): string[] {
  if (value === null || typeof value !== 'object' || Array.isArray(value)) {
    return [];
  }
  const obj = value as Record<string, unknown>;
  const known = TAX_1099K_OPTIONS.filter(option => obj[option] === true);
  const extras = Object.keys(obj).filter(
    key =>
      obj[key] === true &&
      !TAX_1099K_OPTIONS.includes(key as (typeof TAX_1099K_OPTIONS)[number])
  );
  return [...known, ...extras];
}
